// test1697
(1697 && 0);
